import { useSelector } from 'react-redux'

import appSelectors from 'App/duck/selectors'
import clubCardSelectors from 'features/account/club-card/duck/selectors'
import { trackViewEventAdapter } from 'helpers/tracking'

const staticData = {
  category_id: 'myAccount',
}

const useTrackAccountPageView = (): any => {
  const appDataForTrackingPageView = useSelector(appSelectors.getAppPageViewTrackingData)
  const currentTier = useSelector(clubCardSelectors.getCurrentTier)

  const trackPageView = (pageViewId, otherEventsObj): void => {
    if (pageViewId) {
      trackViewEventAdapter({
        ...staticData,
        ...appDataForTrackingPageView,
        ...otherEventsObj,
        customer_club_level: `tier ${currentTier}`,
        page_id: pageViewId,
      })
    }
  }

  return trackPageView
}

export default useTrackAccountPageView
